import LegalPage from "@/components/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      seoDescription="The terms that govern your use of the StUpEco Workspace website and free account during Phase 1."
      path="/terms"
      updated="December 2025"
      intro="These terms govern your use of the StUpEco Workspace website and any free account you create during this phase. By using the site, you agree to these terms."
      sections={[
        {
          heading: "1. Using our website",
          body: [
            "You may use the StUpEco Workspace website for lawful purposes only. You agree not to misuse the site, attempt to disrupt it, or access it in ways not permitted by these terms.",
          ],
        },
        {
          heading: "2. Accounts",
          body: [
            "You are responsible for the information you provide and for keeping your account credentials secure. You must provide accurate details and notify us of any unauthorised use of your account.",
          ],
        },
        {
          heading: "3. Phase 1 — pre-release nature",
          body: [
            "The Workspace application is under active development and is being released in phases. Product modules shown on this site are labelled Available Soon, In Development or Future. Features, timelines and pricing may change.",
            "Creating a free account reserves your place; it does not guarantee availability of any specific module by any specific date.",
          ],
        },
        {
          heading: "4. Communications",
          body: [
            "By opting in, you consent to receive the emails you signed up for (such as product updates or pricing notifications). You can unsubscribe at any time.",
          ],
        },
        {
          heading: "5. Intellectual property",
          body: [
            "The StUpEco Workspace name, logo, content and design are owned by us or our licensors and are protected by applicable laws. You may not copy or reuse them without permission.",
          ],
        },
        {
          heading: "6. Disclaimers",
          body: [
            "The website is provided on an \"as is\" and \"as available\" basis during this phase. To the fullest extent permitted by law, we disclaim warranties of any kind regarding the site's availability or fitness for a particular purpose.",
          ],
        },
        {
          heading: "7. Limitation of liability",
          body: [
            "To the extent permitted by law, StUpEco Workspace will not be liable for indirect, incidental or consequential damages arising from your use of the website.",
          ],
        },
        {
          heading: "8. Changes to these terms",
          body: [
            "We may update these terms as the product evolves. Continued use of the site after changes take effect constitutes acceptance of the updated terms.",
          ],
        },
      ]}
    />
  );
}
